<div class="modal-header">
    <h5 class="modal-title"><i class="fas fa-cash-register mr-2"></i>{{ 'title.cash-register-quick-access' | translate }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()">

    </button>
</div>

<div class="modal-body position-relative">
    <div class="row align-items-center mb-3" *ngIf="!loading && selectedCashRegister">
        <div class="col-auto" *ngIf="cashRegisters.length > 1">
            <label class="custom-form-label mb-0">{{ 'cashRegister.name' | translate }}</label>
        </div>
        <div class="col" *ngIf="cashRegisters.length > 1">
            <select class="form-control form-control-sm" [(ngModel)]="selectedCashRegister" (ngModelChange)="onSelectedCashRegisterChange()">
                <option *ngFor="let cr of cashRegisters" [ngValue]="cr">
                    {{ cr.name }} - {{ cr.vendorType }}
                </option>
            </select>
        </div>
        <div class="col-auto" [class.ms-auto]="cashRegisters.length <= 1">
            <button type="button" class="btn btn-outline-primary btn-sm" (click)="openEditCashRegister()">
                <i class="fas fa-edit mr-1"></i>{{ 'button.edit' | translate }}
            </button>
        </div>
    </div>

    <div *ngIf="loading" class="mb-3">
        <app-skeleton-card [showTitle]="true" [lineCount]="5" [showBadges]="true" [minHeight]="200"></app-skeleton-card>
    </div>

    <div class="row" *ngIf="!loading">
        <div class="col-md-6">
            <div class="card" *ngIf="storeSetting">
                <div class="card-body">
                    <div class="form-check form-switch mb-3">
                        <input type="checkbox" class="form-check-input" name="isCashRegisterActiveForPaymentInput2" id="isCashRegisterActiveForPaymentInput2"
                            [(ngModel)]="storeSetting.isCashRegisterActiveForPayment" [disabled]="isBusySave" />
                        <label class="form-check-label" for="isCashRegisterActiveForPaymentInput2">{{'storeSetting.isCashRegisterActiveForPayment' | translate}}</label>
                    </div>
                    <div class="form-check form-switch mb-3" *ngIf="selectedCashRegister">
                        <input type="checkbox" class="form-check-input" name="isDefaultDeviceInput" id="isDefaultDeviceInput" [(ngModel)]="isDefaultDeviceSelected" [disabled]="isBusySave" />
                        <label class="form-check-label" for="isDefaultDeviceInput">{{'cashRegister.isDefaultDevice' | translate}}</label>
                    </div>
                    <div *ngIf="selectedCashRegister && isLocalVendor()">
                        <label class="custom-form-label">{{ 'common.ip-address' | translate }}</label>
                        <input type="text" class="form-control form-control-lg mb-3" [(ngModel)]="selectedCashRegister.apiUrl" [disabled]="isBusySave" placeholder="http://...">
                    </div>
                    <div *ngIf="selectedCashRegister && hasDeviceCodeField()">
                        <label class="custom-form-label">{{ 'device.deviceCode' | translate }}</label>
                        <input type="text" class="form-control form-control-lg mb-3" [(ngModel)]="selectedCashRegister.deviceCode" [disabled]="isBusySave">
                    </div>
                    <div class="form-group mb-0">
                        <label class="custom-form-label">{{'payment.payment-type-for-cash_register' | translate}}</label>
                        <ng-multiselect-dropdown name="storePermissionForPaymentTypeForCashRegister" class="custom-multi-select" [settings]="paymentTypeDropdownSettings" [data]="paymentTypes"
                            [(ngModel)]="selectedPaymentTypesForCashRegister">
                        </ng-multiselect-dropdown>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-6">
            <div class="action-buttons" *ngIf="selectedCashRegister">
                <div class="row g-3">
                    <div class="col-6" *ngIf="hasOpenShift()">
                        <button class="btn btn-success btn-lg shadow-sm w-100" (click)="openShift()" [disabled]="isBusyOpenShift">
                            <span *ngIf="isBusyOpenShift" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            <i *ngIf="!isBusyOpenShift" class="fas fa-folder-open mr-2"></i>
                            {{ 'button.open-shift' | translate }}
                        </button>
                    </div>

                    <div class="col-6" *ngIf="hasCloseShift()">
                        <button class="btn btn-danger btn-lg shadow-sm w-100" (click)="closeShift()" [disabled]="isBusyCloseShift">
                            <span *ngIf="isBusyCloseShift" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            <i *ngIf="!isBusyCloseShift" class="fas fa-times-circle mr-2"></i>
                            {{ 'button.close-shift' | translate }}
                        </button>
                    </div>

                    <div class="col-6" *ngIf="hasGetXReport()">
                        <button class="btn btn-info btn-lg shadow-sm w-100" (click)="getXReport()" [disabled]="isBusyXReport">
                            <span *ngIf="isBusyXReport" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            <i *ngIf="!isBusyXReport" class="fas fa-file-alt mr-2"></i>
                            {{ 'button.get-x-report' | translate }}
                        </button>
                    </div>

                    <div class="col-6" *ngIf="isPavoVendor()">
                        <button class="btn btn-warning btn-lg shadow-sm w-100" (click)="pairDevice()" [disabled]="isBusyPairDevice">
                            <span *ngIf="isBusyPairDevice" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            <i *ngIf="!isBusyPairDevice" class="fas fa-link mr-2"></i>
                            {{'button.pair-device' | translate}}
                        </button>
                    </div>

                    <div class="col-6" *ngIf="isBekoVendor() ||isOdealVendor()">
                        <button class="btn btn-outline-danger btn-lg shadow-sm w-100" (click)="clearBasket()" [disabled]="isBusyClearBasket">
                            <span *ngIf="isBusyClearBasket" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            <i *ngIf="!isBusyClearBasket" class="fas fa-trash-alt mr-2"></i>
                            {{'button.clear-basket' | translate}}
                        </button>
                    </div>
                </div>
            </div>

            <div *ngIf="!selectedCashRegister" class="text-center text-muted py-5">
                <i class="fas fa-info-circle fa-3x mb-3"></i>
                <p>{{ 'message.info.select-cash-register' | translate }}</p>
            </div>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-lg" (click)="close()">
        <i class="fas fa-times mr-2"></i>{{ 'button.close' | translate }}
    </button>
    <button type="button" class="btn btn-primary btn-lg" (click)="save()" [disabled]="isBusySave" *ngIf="storeSetting">
        <span *ngIf="isBusySave" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        <i *ngIf="!isBusySave" class="fas fa-save me-2"></i> {{ 'button.save' | translate }}
    </button>
</div>